import { render, staticRenderFns } from "./merchantModel.vue?vue&type=template&id=4a7ce0fc"
import script from "./merchantModel.vue?vue&type=script&lang=js"
export * from "./merchantModel.vue?vue&type=script&lang=js"
import style0 from "./merchantModel.vue?vue&type=style&index=0&id=4a7ce0fc&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a7ce0fc')) {
      api.createRecord('4a7ce0fc', component.options)
    } else {
      api.reload('4a7ce0fc', component.options)
    }
    module.hot.accept("./merchantModel.vue?vue&type=template&id=4a7ce0fc", function () {
      api.rerender('4a7ce0fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/merchantManage/merchantModel.vue"
export default component.exports